<template>
<div style="height:100%;width:100%; display: flex;flex-direction: column;">

    <div style="height:50px;width:100%;background-color:#f8f8f8;">
    
    <div  style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">
      
    <div style="width:40%;display:flex" > 
      <div style="width:4px;background-color:#970B0B;height:40px"></div> 
      <div style="margin:5px;color:#970B0B;">升级管理</div> 
    </div>
   

       <div style="width:50%;justify-content: center;display: flex;">

            <div style="display: flex;margin-left:0px;margin-top:-11px;">
      <div style="flex: 1;width:200px;margin:5px;margin-right:0px">项目：</div>
        <el-select @change="selectChangeProject" size = "medium" placeholder="请选择项目" v-model="project" >

          <el-option
            v-for="item in ccprojectList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>


      <!--  <div style="display: flex;margin-top:-11px">
            <el-input
            style="width:220px;"
             placeholder="请输入10位projectkey"
             v-model="projectkey"
             maxlength="10"
             type="text"
             clearable>
            </el-input>
        </div> -->
        
    </div>
    <div style="width:15%;color:#970B0B">
        <el-button  @click="RightAddClick"  size="mini" style="width:70%;background-color:#970B0B;color:#fff">查询</el-button> 

    </div>

    </div>

    </div>

<div style="width:100%;height:100%">
  

                  


    <el-table 
    :data="groupIist"
     height="500px"
    size= "medium"
    :row-style="tableRowStyle"
    style="width: 100%;">
    <el-table-column
      fixed
      prop="id"
      label="ID"
      width="80">
    </el-table-column>

    <el-table-column
      fixed
      prop="cid"
      label="CID"
      width="180">
    </el-table-column>
    


    <el-table-column
      prop="version"
      label="版本"
      width="100">
    </el-table-column>


    <el-table-column
      prop="mac"
      label="MAC/IMEI"
      width="150">
    </el-table-column>
    <el-table-column
      prop="imei"
      label="IMEI"
      width="150">
    </el-table-column>

    <el-table-column
      prop="coreversion"
      label="固件版本"
      width="100">
    </el-table-column>

    <el-table-column
      prop="devicebsp"
      label="硬件类型"
      width="100">
    </el-table-column>
    
        <el-table-column
      prop="updateDate"
      label="最近登入时间"
      width="200">
    </el-table-column>

    <el-table-column
      prop="projectkey"
      label="项目编码"
      width="200">
    </el-table-column>


    <el-table-column
      prop="product"
      label="产品名称"
      width="200">
    </el-table-column>

    <el-table-column
      prop="productKey"
      label="产品编码"
      width="200">
    </el-table-column>



    <el-table-column
      
      prop="aid"
      label="用户AID"
      width="80">
    </el-table-column>



    <el-table-column
      prop="createTime"
      label="首次登入时间"
      width="200">
    </el-table-column>



    <el-table-column
      fixed="right"
      label="操作"
      width="180">
     <template slot-scope="scope">
      <el-button
          size="mini"
          
          @click="handleEdit(scope.$index, scope.row)">软件升级</el-button>
        <el-button
          size="mini"
          disabled
          
          @click="handleDelete(scope.$index, scope.row)">删除</el-button>

      </template>
    </el-table-column>

  </el-table>
  


</div>

 <el-pagination
      style="text-align:center;margin:10px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageInfo.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
</el-pagination>


<el-dialog
  :visible.sync="centerDialogVisible"
  width="80%"
  center
  :destroy-on-close = true
  :show-close = false
  :close-on-click-modal = false
  :close-on-press-escape = false
  >
<div>
      <div style="height:40px;width:100%;background-color:#fff;">
        <div  style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">
          
            <div style="width:40%;display:flex" > 
              <div style="width:4px;background-color:#970B0B;height:40px"></div> 
              <div style="margin:5px;color:#970B0B;">软件升级</div> 
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
        </div>
    </div>

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
        <div  style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">
          
      
    <div style="width:70%;display:flex" > 
             
              
      <div v-if="isGroupEdit" style="display: flex;margin:10px;margin-top:15px;">
          <div style="flex: 1;width:200px;margin-left:5px;margin-right:15px">CID：{{groupInfo.cid}}
        </div>
      </div>


     <div style="display: flex;margin-left:30px;margin-top:10px;">
      <div style="flex: 1;width:200px;margin:5px;margin-right:10px">软件版本：</div>
        <el-select @change="selectChange"  size = "medium" placeholder="请选择软件版本" v-model="cupdateversion" >

          <el-option
            v-for="item in ccversionList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>


   </div>


      <div style="width:50%;justify-content: center;display: flex;"></div>
         <div style="width:15%;color:#970B0B"></div>
      </div>
    </div>
    <div style="color:#970B0B;font-size:13px;margin:20px 0px 0px 20px">重要：①设备必须在线，②点击“确定”按钮将跳转至设备详情界面自动升级！FOTA升级中，请不要进行任何操作！</div>

</div>

  <span slot="footer" class="dialog-footer ">
    <el-button style="width:120px"  @click="cancelBtn">取 消</el-button>
    <el-button style="background-color:#970B0B;color:#fff;width:120px"  @click="addGroup">确 定</el-button>
  </span>
</el-dialog>


</div>

</template>

<script>

import TMApipath from 'TMApipath'
import TMStore from 'TMStore'
import {formatTimestamp,formatTime} from 'TMUtils'


  export default {
    methods: {
      handleSizeChange(val) {
        var _this =this;
        _this.pageInfo.size =  val;
        _this.getDeviceRecordListByPage(_this.pageInfo.val,_this.pageInfo.size);
      },
      cancelBtn(){
          var _this =this;
          _this.centerDialogVisible = false;
          _this.groupInfo = {}



      },
      
      handleAlert(index, rows) {//待实现
        var _this =this;
        console.log(`当前页: ${index}`);
        console.log(`当前页: ${rows}`);

        _this.$confirm('提醒：将跳转至设备详情界面进自动升级！另外，升级时请不要进行远程控制！是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {

//调整设备详情界面

          _this.$router.push({name: 'DeviceDetail',query: _this.groupInfo})




        }).catch(() => {
                 
        });

      },
      tableRowStyle() {
         return { "height": "20px" }
          
      },
      handleEdit(index, rows) {//待实现
        this.centerDialogVisible =  true;
        this.isGroupEdit =  true;
        this.cupdateversion = '';

         this.groupInfo = {
          cid: rows.cid,
          updateversion: "",
          updateurl: "",

        }

      },
      
      handleDelete(index, rows) {//待实现
        var _this =this;

        _this.$confirm('此操作将永久删除该条数据, 是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {

         _this.deleteGroup(rows.cid)



        }).catch(() => {
                 
        });

      },
      deleteGroup(cid){

          var _this = this

          var params = {
            cid: cid
          }


         var reqdata = {}
          var { urls} = _this.getresult(TMApipath.DEVICE,TMApipath.URL_API_deleteDeviceRecord, reqdata);

           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.post(urls, params).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {

              // vuex记录
               _this.getDeviceRecordListByPage(_this.pageInfo.val,_this.pageInfo.size);

            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
      selectChange(val){//匹配对应的VISON
        var _this = this

          for(var items in _this.versionList){
                var item = _this.versionList[items]


               if (item.updateversion === val) {
                  _this.groupInfo.updateversion = item.updateversion;
                  _this.groupInfo.updateurl = item.updateurl;
                  break;
               }

          }
      },
      handleCurrentChange(val){
        console.log(`当前页: ${val}`);
        // console.log(`当前页: ${val}`);
        var _this = this
        _this.pageInfo.val = val
        _this.getDeviceRecordListByPage(_this.pageInfo.val,_this.pageInfo.size);

      },
      preclick(val){
        console.log(`当前页: ${val}`);

      },
      RightAddClick(){
        var _this =this

          if (!_this.projectkey || (_this.projectkey.length!=10)) {
              this.$message.error("请输入10位 projectkey");
            return
          }



      _this.getDeviceRecordListByPage(_this.pageInfo.val,_this.pageInfo.size);
        

      },
     getDeviceRecordListByPage(pageIndex, pageSize){

          var _this = this

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize,projectkey:_this.projectkey}
          var { urls} = _this.getresult(TMApipath.DEVICE, TMApipath.URL_API_GETDEVICERECORDLISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls,reqdata ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录
                _this.pageInfo.total = response.data.total

                _this.groupIist =[];

              for(var items in response.data.list){
                var item = response.data.list[items]


                var cutFeed ={

                  id: item.id,
                  aid: item.aid,
                  cid: item.cid,
                  mac: item.mac,

                  coreversion: item.coreversion,
                  devicebsp: item.devicebsp,
                  imei: item.imei,

                  product:item.product,
                  productKey:item.productKey,

                  projectkey:item.projectkey,
                  version: item.version,
                  createTime: formatTimestamp(item.createDate),
                  updateDate: formatTimestamp(item.updateDate),

                }

                _this.groupIist.push(cutFeed);
              }


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },

  
      
      getSoftwareListByPage(pageIndex, pageSize){

          var _this = this 

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize}
          var { urls} = _this.getresult(TMApipath.FOTA, TMApipath.URL_API_GETSOFTWARELISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.versionList =[];
                _this.ccversionList =[];

              for(var items in response.data.list){
                var item = response.data.list[items]

                 var cutFeed ={
                  id: item.id,
                  updateversion: item.updateversion,
                  updateurl: item.updateurl,
                  project: item.project,
                  size: item.size,
                  unit: item.size +' '+ item.unit,
                  func: item.func,
                  notes: item.notes,
                  createTime: formatTime(item.createDate),
                  updateTime: item.updateTime ? formatTime(item.updateDate): '--'

                }

                var cccutFeed ={
                  label: item.updateversion+'（'+item.product+'_'+item.project+'）',
                  value: item.updateversion,
                }


                _this.versionList.push(cutFeed);
                _this.ccversionList.push(cccutFeed);
              }


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });


      },
      addGroup(){

          var _this = this;
          _this.groupInfo.updateversion =  _this.cupdateversion

          if (!_this.groupInfo.cid || !_this.groupInfo.updateurl || !_this.groupInfo.updateversion) {
              this.$message.error("请选择软件的升级版本");
            return
          }
 
          var params = _this.groupInfo;

          console.log(params);
          _this.handleAlert();

      },
      selectChangeProject(val){//匹配对应的VISON
        var _this = this

          for(var items in _this.ccprojectList){
                var item = _this.ccprojectList[items]


               if (item.value === val) {
                  _this.projectkey = item.value;
                  _this.project = item.label;

                  _this.getDeviceRecordListByPage(_this.pageInfo.val,_this.pageInfo.size);

                  break;
               }

          }
      },
      getConfigProjectListByPage(pageIndex, pageSize){

          var _this = this 

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize}
          var { urls} = _this.getresult(TMApipath.CONFIGMANAGE,TMApipath.URL_API_GETCONFIGPROJECTLISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.ccprojectList =[];

                // _this.pageInfo.total = response.data.total

              for(var items in response.data.list){
                var item = response.data.list[items]

                var cutFeed ={
                  id: item.id,
                  project: item.project,
                  projectkey: item.projectkey,

                  value:item.projectkey,
                  label:item.project,

                }

                _this.ccprojectList.push(cutFeed);
              }


              //自动设置拉取数据
              if (_this.ccprojectList.length > 0 && _this.role != 'admin') {
                    var cprojcet = _this.ccprojectList[0]
                    _this.projectkey = cprojcet.projectkey;
                    _this.project = cprojcet.project;

                    _this.getDeviceRecordListByPage(_this.pageInfo.val,_this.pageInfo.size);

              }



            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });


      },

    },
    mounted() {
      var _this = this
      _this.getDeviceRecordListByPage(_this.pageInfo.val,_this.pageInfo.size);
      _this.getSoftwareListByPage(1,100);
       _this.getConfigProjectListByPage(1,100);

      
    },
    data() {
      return {

        versionList: [],
        ccversionList:[],
        cupdateversion: '',
        pageInfo:{
          val:1,
          size: 10,
          total:0
        },
        centerDialogVisible: false,
        isGroupEdit:false,

        groupInfo:{
          cid: '',
          updateurl: '',
          updateversion: ''
        },
        groupIist: [],
        projectkey:'',
        project:'',
        ccprojectList:[],
        role:TMStore.state.account.role,

      }
    }
  }
</script>

<style lang="stylus" scoped>

.groups
    overflow: hidden

.rightButton
  width: 30px
.container_right
    margin: 5px
    display: flex
    justify-content: center
    align-items: flex-start
.el-dialog_header
    padding:0px
</style>